export const icerikler = {
    title: 'İçerikler',
    titleEN: 'Contents',
    description: 'Yemek.com\'da yer alan, kullanıcıların ilgisini çeken ve etkileşim alan içeriklerdir.',
    descriptionEN: 'These are contents featured on Yemek.com that attract user interest and engagement.',
    tabs: [
        {
            id: 1,
            title: 'İçerikler',
            sliderPerView: 3,
            width: '100%',
            slides: [
                {
                    id: 1,
                    // name: 'Özel Tarifler',
                    image: 'https://srv-cdn.onedio.com/store/a8abe5d573c4c3706bb46299a13dd80bf455023c3b7c1279f4832868e61fcce5.png',
                    description: 'Yemek.com\'a özel deneyimli şeflerden tarifler',
                    url: 'https://yemek.com/tarif/cikolatali-baklava-kaseleri/'
                }
            ]
        }
    ],
    egTabs: [
        {
            id: 1,
            title: 'Recipes and Recommendations',
            sliderPerView: 3,
            width: '100%',
            slides: [
                {
                    id: 1,
                    // name: 'Special Recipes',
                    image: 'https://srv-cdn.onedio.com/store/a8abe5d573c4c3706bb46299a13dd80bf455023c3b7c1279f4832868e61fcce5.png',
                    description: 'Recipes from experienced chefs exclusive to Yemek.com',
                    url: 'https://yemek.com/tarif/cikolatali-baklava-kaseleri/'
                }
            ]
        }
    ]
} 